import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IEmployeeSFilter } from 'src/@types/SearchFilterTypes';
import { Page } from 'src/components/Page';

import EmployeeGrid from './EmployeeGrid';
import SearchForm from './SearchForm';

export const Employee = observer(() => {
  // 검색 조건
  const [searchData, setSearchData] = useState<IEmployeeSFilter>({} as IEmployeeSFilter);

  // 목록 검색
  const onSearch = (data: IEmployeeSFilter) => {
    setSearchData(data);
  };

  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <EmployeeGrid searchData={searchData} />
    </Page>
  );
});

export default Employee;
